<template>
  <div class="addClaim">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('receivablesManage.collapseTitle.baseTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <BasicInfo
            :canEdit="canEdit"
            :disabledBusinessType="disabledBusinessType"
            :departmentList="departmentList"
            @getDepartment="getDepartment"
            :receiveStatusType="'Claim'"
            ref="basicInfo"
            @updateFormData="updateFormDataFormHandler"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('receivablesManage.collapseTitle.receivablesTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <ReceivablesInfo
            :canEdit="canEdit"
            ref="receivablesInfo"
            @updateFormData="updateFormData"
            @saveAnotherPay="saveAnotherPay"
            @saveAnotherPayTime="saveAnotherPayTime"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('receivablesManage.collapseTitle.receivablesClaimTitle') }}</div
          >
        </template>
        <div class="collapse-content padding0">
          <el-tabs
            type="border-card"
            v-model="tabActiveNames"
            @tab-click="handleTabClick"
            :beforeLeave="beforeLeave"
          >
            <!-- 一次认领 -->
            <el-tab-pane
              :label="this.$t('receivablesManage.tabTitle.firstClaimsTitle')"
              name="first"
            >
              <FirstClaim
                :canEdit="firstClaimCanEdit"
                :formData="formData"
                :departmentList="departmentList"
                :firstUnClaimedAmount="firstUnClaimedAmount"
                :secondUnClaimAmountList="secondUnClaimAmountList"
                :businessType="businessType"
                @saveData="saveData"
                @getAllData="getTableData"
                ref="firstClaim"
                @sysConfigFlagChange="sysConfigFlagChange"
              />
            </el-tab-pane>
            <!-- 二次认领 -->
            <el-tab-pane
              :label="this.$t('receivablesManage.tabTitle.secondClaimsTitle')"
              name="second"
            >
              <SecondClaimHN
                v-if="sysConfigFlag == 'Y'"
                :formData="formData"
                :contractCategory="contractCategory"
                :departmentList="departmentList"
                :secondUnClaimAmountList="secondUnClaimAmountList"
                :firstUnClaimedAmount="firstUnClaimedAmount"
                :businessType="businessType"
                @secondClaim="secondClaim"
                ref="secondClaim"
              />
              <SecondClaim
                v-else
                :formData="formData"
                :contractCategory="contractCategory"
                :departmentList="departmentList"
                :firstUnClaimedAmount="firstUnClaimedAmount"
                :secondUnClaimAmountList="secondUnClaimAmountList"
                :businessType="businessType"
                @secondClaim="secondClaim"
                ref="secondClaim"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <!-- 收款认领 -->
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre"
            ><span></span>{{ $t('receivablesManage.collapseTitle.orderTitle') }}</div
          >
        </template>
        <div class="collapse-content">
          <OrderInfo ref="orderInfo" />
        </div>
      </el-collapse-item>
      <el-collapse-item name="5">
        <!--上传附件-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            {{ $t('receivablesManage.collapseTitle.uploadFileTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <div>
            <upload
              ref="upload"
              @upload="handleUpload"
              v-bind:tableData="capitalAttachmentList"
              v-bind:isShow="true"
            />
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <!-- <el-button
        :disabled="
          formData.receiveStatus != '03' ||
          ((formData.isAnotherPay == 'Y' || formData.isAnotherPay == true) &&
            formData.financeAuditStatus != '002')
        "
        type="primary"
        @click="makeCollections"
        class="fixed-bottom-btn"
        >{{ $t('receivablesManageList.button.createReceipt') }}</el-button
      > -->
      <!-- 财务审核驳回后 可再次提交财务审核 -->
      <!-- <el-button
        v-if="
          this.isAnotherPay != null
            ? this.isAnotherPay
            : formData.isAnotherPay == 'Y' || formData.isAnotherPay == true
            ? true
            : false
        "
        :disabled="
          ['00', '01', '02'].indexOf(formData.receiveStatus) != -1 ||
          ['001', '002'].indexOf(formData.financeAuditStatus) != -1
        "
        type="primary"
        @click="submitFinanceAudit"
        class="fixed-bottom-btn"
        >{{ $t('receivablesManageList.button.submitFinanceAudit') }}</el-button
      >
      <el-button
        v-hasPermi="['2021031114461868381']"
        v-if="
          this.isAnotherPay != null
            ? this.isAnotherPay
            : formData.isAnotherPay == 'Y' || formData.isAnotherPay == true
            ? true
            : false
        "
        :disabled="formData.financeAuditStatus != '001'"
        type="primary"
        @click="passFinanceAudit"
        class="fixed-bottom-btn"
        >{{ $t('receivablesManageList.button.passFinanceAudit') }}</el-button
      >
      <el-button
        v-hasPermi="['2021031114494838614']"
        v-if="
          this.isAnotherPay != null
            ? this.isAnotherPay
            : formData.isAnotherPay == 'Y' || formData.isAnotherPay == true
            ? true
            : false
        "
        :disabled="formData.financeAuditStatus != '001'"
        type="primary"
        @click="rejectFinanceAudit"
        class="fixed-bottom-btn"
        >{{ $t('receivablesManageList.button.rejectFinanceAudit') }}</el-button
      > -->
      <el-button type="primary" @click="pushGoldie" class="fixed-bottom-btn">{{
        $t('receivablesManageList.button.pushGoldie')
      }}</el-button>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/capitalCenter/receivablesManage';
  // import PATNER from '@/api/masterData/cooperation';
  import BasicInfo from './components/basicInfo'; // 基本信息
  import ReceivablesInfo from './components/receivablesInfo'; // 收款信息
  import OrderInfo from './components/orderInfo'; // 收款单
  import FirstClaim from './components/firstClaim'; // 一次认领信息
  import SecondClaim from './components/secondClaim'; // 二次认领信息
  import SecondClaimHN from './components/secondClaimHN'; // 二次认领信息-海宁
  // import qs from 'qs';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  import upload from '@/components/upload';
  export default {
    name: 'addClaimCK',
    components: {
      BasicInfo, // 基本信息
      ReceivablesInfo, // 收款信息
      OrderInfo, // 收款单
      FirstClaim, // 一次认领信息
      SecondClaim, // 二次认领信息
      SecondClaimHN, // 二次认领信息海宁
      upload,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 待拆分收款信息表格
      columnList() {
        return [
          {
            // 序号
            type: 'seq',
            width: 90,
            title: this.$t('receivablesManageList.claimColumn.seq'),
          },
          {
            // 收款登记号
            field: 'registerNo',
            title: this.$t('receivablesManageList.claimColumn.registerNo'),
          },
          {
            // 公司代码
            field: 'registerCompanyCode',
            title: this.$t('receivablesManageList.claimColumn.registerCompanyCode'),
          },
          {
            // 付款单位
            field: 'payerName',
            title: this.$t('receivablesManageList.claimColumn.payerName'),
          },
          {
            // 收款日期
            field: 'registerDate',
            title: this.$t('receivablesManageList.claimColumn.registerDate'),
          },
          {
            // 形式发票金额
            field: 'originProformaInvoiceAmount',
            title: this.$t('receivablesManageList.claimColumn.originProformaInvoiceAmount'),
          },
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title: this.$t('receivablesManageList.claimColumn.originReceiveMoneyAmount'),
          },
          {
            // 国内银行扣费
            field: 'originDomesticBankDeductFee',
            title: this.$t('receivablesManageList.claimColumn.originDomesticBankDeductFee'),
          },
          {
            // 国外银行扣费
            field: 'originForeignBankDeductFee',
            title: this.$t('receivablesManageList.claimColumn.originForeignBankDeductFee'),
          },
          {
            // 收款状态
            field: 'receiveStatus',
            title: this.$t('receivablesManageList.claimColumn.receiveStatus'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('receiveClaimStatus'),
              props: {
                clearable: true,
                filterable: true,
              },
            },
          },
        ];
      },
      // 一次认领二次认领编辑状态
      firstClaimCanEdit() {
        if (this.formData.id) {
          // 已生成收款单不可进行一次认领
          //代付情况审核通过和审批中都不可进行一次认领
          if (
            this.formData.receiveStatus == '04' ||
            this.formData.financeAuditStatus == '001' ||
            this.formData.financeAuditStatus == '002'
          ) {
            return false;
          } else {
            // 未生成收款单可进行一次认领
            return true;
          }
        } else {
          return false;
        }
      },
    },
    props: ['canEdit', 'disabledBusinessType'],
    data() {
      return {
        name: 'claim',
        activeNames: ['0', '1', '2', '3', '4', '5'],
        tabActiveNames: 'first',
        // 待拆分收款信息表格当前所选行信息
        formData: {},
        tableData: [],
        isAnotherPay: null,
        firstUnClaimedAmount: {
          // 一次未认领
          originProformaInvoiceAmount: null, // 形式发票金额
          localProformaInvoiceAmount: null, // 形式发票金额（本币）
          originReceiveMoneyAmount: null, // 收款金额
          localReceiveMoneyAmount: null, // 收款金额（本币）
          originDomesticBankDeductFee: null, // 国内银行扣费
          localDomesticBankDeductFee: null, // 国内银行扣费（本币）
          originForeignBankDeductFee: null, // 国外银行扣费
          localForeignBankDeductFee: null, // 国外银行扣费（本币）
        },
        secondUnClaimAmountList: [], // 二次未认领列表
        departmentList: [], // 部门
        contractCategory: null, // 合同种类
        sysConfigFlag: null, // 系统配置标识 海宁：Y
        capitalAttachmentList: [], // 附件列表
        fundCollectionOrderList: [], // 结算单
        businessType: null,
      };
    },
    mounted() {
      this.getTableData(); // 获取待拆分收款信息列表数据
      this.$nextTick(() => {
        this.businessType = this.$route.query.businessType;
      });
    },
    methods: {
      updateFormDataFormHandler(formData) {
        this.businessType = formData.businessType;
      },
      sysConfigFlagChange(val) {
        this.sysConfigFlag = val;
      },
      async getDepartment(companyCode, id) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                ...item,
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (this.departmentList.length == 0) {
              this.$message({ showClose: true, message: '缺少对应部门，请维护', type: 'error' });
            }
            this.getDetail(id);
          }
        } else {
          this.departmentList = [];
        }
      },
      async getTableData(id) {
        // 获取待拆分收款信息列表数据
        let ids = JSON.parse(this.$route.query.ids);
        this.loading.startLoading();
        let res = await this.$axios.post(API.QUERY_COLLECTIONCLAIM_REGISTER, ids);
        console.log(res, '表格数据');
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.tableData = res.data.data;
            if (id) {
              this.tableData.map((item) => {
                if (item.id == id) {
                  this.$refs.tableData?.setCurrentRow(item);
                  this.formData = item;
                }
              });
            } else {
              this.$refs.tableData?.setCurrentRow(this.tableData[0]);
              this.formData = this.tableData[0];
            }
            this.getDepartment(this.formData.registerCompanyCode, this.formData.id);
            this.queryAttachment(this.formData.registerNo);
            if (this.formData.receiveStatus == '04') {
              this.tabActiveNames = 'second';
            }
          }
        }
      },
      async getDetail(id) {
        // 获取收款详情数据
        let departNos =
          this.departmentList.length > 0
            ? this.departmentList.map((item) => {
                return item.value;
              })
            : [];
        this.loading.startLoading();
        let res = await this.$axios.post(API.QUERY_COLLECTIONCLAIM_BY_ID, { id, departNos });
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            let allDetail = res.data.data;
            this.$refs.orderInfo.tableData = allDetail.fundCollectionOrderList.map((item) => {
              return {
                ...item,
                receiveStatus: this.dictListMap?.receiveStatus.find(
                  (item1) => item1.value == item.receiveStatus
                )?.label,
              };
            });
            ['basicInfo', 'receivablesInfo'].forEach((item) => {
              // 基本信息、收款信息表单数据初始化
              let baseData = this.$refs[item].baseData;
              Object.keys(baseData).map((i) => {
                if (i.indexOf('is') == 0) {
                  return (baseData[i] = allDetail[i] == 'Y' ? true : false);
                } else {
                  return (baseData[i] = allDetail[i]);
                }
              });
            });
            // ['basicInfo','receivablesInfo'].map(item=>{ // 基本信息、收款信息表单数据初始化
            //   let baseData = this.$refs[item].baseData;
            //   Object.keys(baseData).map(i=>{
            //     if (i.indexOf('is') == 0) {
            //       baseData[i] = allDetail[i]=='Y'?true:false;
            //     } else {
            //       baseData[i] = allDetail[i];
            //     }
            //   });
            // });
            Object.keys(this.firstUnClaimedAmount).map((item) => {
              // 一次未认领金额
              return (this.firstUnClaimedAmount[item] =
                allDetail.fundCollectionFirstUnClaimAmount[item]);
            });
            this.secondUnClaimAmountList = allDetail.fundCollectionSecondUnClaimAmountList; // 二次未认领金额列表
            // =========================== 以下是认领明细信息 ======================================
            this.getFirstClaimInfo(allDetail); // 初始化一次认领tab页信息
            this.getSecondClaimInfo(allDetail); // 初始化二次认领tab页信息
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      getFirstClaimInfo(val) {
        // 初始化一次认领tab页信息
        let firstClaim = this.$refs.firstClaim;
        firstClaim.tableDataInit = XEUtils.clone(val.fundCollectionFirstClaimList, true);
        firstClaim.secondTableDataInit = XEUtils.clone(val.fundCollectionSecondClaimList, true);
        firstClaim.tableData = XEUtils.clone(val.fundCollectionFirstClaimList, true);
        if (val.fundCollectionFirstClaimList.length == 0) {
          // 初始化默认一行
          this.resolveFirstClaimTableData(val);
        } else {
          ['customerNo', 'customerName', 'claimPartnerNo', 'claimPartnerName'].map((item) => {
            return (firstClaim[item] = firstClaim.addRowObj[item] =
              val.fundCollectionFirstClaimList[0][item]);
          });
          this.contractCategoryCtrl(val.fundCollectionFirstClaimList[0]);
        }
        firstClaim.updateData();
        firstClaim.del = [];
      },
      getSecondClaimInfo(val) {
        // 初始化二次认领tab页信息
        let secondClaim = this.$refs.secondClaim;
        //应收票据托收贴现，收款登记不允许二次认领
        secondClaim.firstClaimNoList = [];
        val.fundCollectionFirstClaimList.map((item, idx) => {
          // 一次认领行项目号列表
          if (!['RT02', 'RT03'].includes(item.receivedType)) {
            secondClaim.firstClaimNoList.push({ label: idx + 1, value: Number(item.id), ...item });
          }
        });
        // 给二次认领塞值
        secondClaim.tableData = XEUtils.clone(val.fundCollectionSecondClaimList, true); // 表格信息
        secondClaim.updateData(); // 更新表格
        secondClaim.del = [];
      },
      // resolveFirstClaimTableData(allDetail) { // 一次认领初始化默认一行
      //   let firstClaim = this.$refs.firstClaim;
      //   firstClaim.tableDataInit = XEUtils.clone(val.fundCollectionFirstClaimList, true);
      //   firstClaim.secondTableDataInit = XEUtils.clone(val.fundCollectionSecondClaimList, true);
      //   firstClaim.tableData = XEUtils.clone(val.fundCollectionFirstClaimList, true);
      //   if (val.fundCollectionFirstClaimList.length == 0) { // 初始化默认一行
      //     this.resolveFirstClaimTableData(val);
      //   } else {
      //     ['customerNo','customerName','claimPartnerNo','claimPartnerName'].map(item=>{
      //       return firstClaim[item] = firstClaim.addRowObj[item] = val.fundCollectionFirstClaimList[0][item];
      //     });
      //     this.contractCategoryCtrl(val.fundCollectionFirstClaimList[0]);
      //   }
      //   firstClaim.updateData();
      //   firstClaim.del = [];
      // },
      resolveFirstClaimTableData(val) {
        // 一次认领初始化默认一行
        let firstClaim = this.$refs.firstClaim;
        firstClaim.receiveMethodCtrl(val.receiveMethod); // 收款方式逻辑控制
        firstClaim.preclaimDepartmentCtrl(val); // 预认领部门逻辑控制
        firstClaim.payTypeCtrl(val); // 付款单位类型逻辑控制
        firstClaim.resolveTableData();
      },
      contractCategoryCtrl(val) {
        console.log(val, '-------------二次认领判断合同类型');
        // 二次认领，判断是销售合同还是采购合同
        let secondClaimRow = this.$refs.secondClaim.addRowObj;
        secondClaimRow.customerNo = val.customerNo ? val.customerNo : val.claimPartnerNo;
        secondClaimRow.customerName = val.customerNo ? val.customerName : val.claimPartnerName;
        this.contractCategory = val.customerNo ? 'sales' : 'purchase'; // sales 销售 purchase采购
      },
      currentChange(val) {
        // 点击待拆分收款信息获取详情
        this.formData = val.row;
        if (this.formData.receiveStatus == '04') {
          this.tabActiveNames = 'second';
        }
        this.getDetail(this.formData.id);
      },
      makeCollections() {
        // 生成收款单
        this.saveData([this.formData.id], 'CREATE_COLLECTIONCLAIM_ORDER');
      },
      async pushGoldie() {
        // 推送金蝶
        let params = {
          ids: [this.formData.id],
        };
        this.loading.startLoading();
        const res = await this.$axios.post(API.TRANSACTION_WRITE_CLAIM, {
          ...params,
          businessGroup: this.userInfo.businessGroup,
        });
        this.loading.endLoading();
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            type: 'success',
            message: res.data.msg,
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: res.data.msg,
          });
        }
      },
      async submitFinanceAudit() {
        // 提交财务审核
        let firstClaimData = await this.$refs.firstClaim.exportChildData();
        if (firstClaimData) {
          let tableData = firstClaimData.fundCollectionFirstClaimList;
          let params = this.$baseRequest.assignObj({
            registerNo: this.formData.registerNo,
            customerNo: tableData[0].customerNo,
            customerName: tableData[0].customerName,
            claimPartnerNo: tableData[0].claimPartnerNo,
            claimPartnerName: tableData[0].claimPartnerName,
            isAnotherPay: 'Y',
            anotherPayTime: this.formData.anotherPayTime, // 代付时间
          });
          this.saveData(params, 'SUBMIT_FINANCEAUDIT');
        }
      },
      async saveAnotherPay(value, time) {
        // 勾选代付出发后台更新操作
        let params = this.$baseRequest.assignObj({
          id: this.formData.id,
          isAnotherPay: value ? 'Y' : 'N',
          anotherPayTime: time,
        });
        if (params.isAnotherPay == 'N') {
          params.anotherPayTime = null;
          params.financeAuditStatus = null;
        }
        this.isAnotherPay = value;
        this.saveData(params, 'SAVE_ANOTHERPAY');
      },
      async saveAnotherPayTime(value) {
        // 代付情况下，代付时间的更新
        let params = this.$baseRequest.assignObj({
          id: this.formData.id,
          isAnotherPay: 'Y',
          anotherPayTime: value,
        });
        this.isAnotherPay = true;
        this.saveData(params, 'SAVE_ANOTHERPAY');
      },
      async passFinanceAudit() {
        // 财务审核通过
        let firstClaimData = await this.$refs.firstClaim.exportChildData();
        if (firstClaimData) {
          let tableData = firstClaimData.fundCollectionFirstClaimList;
          let params = this.$baseRequest.assignObj({
            registerNo: this.formData.registerNo,
            customerNo: tableData[0].customerNo,
            customerName: tableData[0].customerName,
            claimPartnerNo: tableData[0].claimPartnerNo,
            claimPartnerName: tableData[0].claimPartnerName,
          });
          this.saveData(params, 'PASS_FINANCEAUDIT');
        }
      },
      rejectFinanceAudit() {
        // 财务审核驳回
        this.saveData({ registerNo: this.formData.registerNo }, 'REJECT_FINANCEAUDIT');
      },
      async saveData(params, apiName) {
        this.loading.startLoading();
        let res = await this.$axios.post(API[apiName], params);
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({
              showClose: true,
              type: 'success',
              message: res.data.msg,
            });
            this.getTableData(this.formData.id);
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg,
            });
          }
        }
      },
      secondClaim(params) {
        this.loading.startLoading();
        this.$axios
          .post(API.SAVE_COLLECTIONCLAIM_SECOND, { ...params, overAmountVerification: 'Y' })
          .then((res) => {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({ showClose: true, type: 'success', message: res.data.msg });
              this.getTableData(this.formData.id);
            } else {
              if (res.data.msg.indexOf('ERROR50001') != -1) {
                this.$confirmAction(
                  res.data.msg.replace('ERROR50001', ''),
                  this.$t('receivablesManage.message.save')
                )
                  .then(() => {
                    this.loading.startLoading();
                    this.$axios
                      .post(API.SAVE_COLLECTIONCLAIM_SECOND, {
                        ...params,
                        overAmountVerification: 'N',
                      })
                      .then((res) => {
                        this.loading.endLoading();
                        if (res.data.code == 0) {
                          this.$message({
                            showClose: true,
                            type: 'success',
                            message: res.data.msg,
                          });
                          this.getTableData(this.formData.id);
                        } else {
                          this.$message({ showClose: true, type: 'error', message: res.data.msg });
                        }
                      });
                  })
                  .catch(() => {
                    this.$message({
                      showClose: true,
                      type: 'info',
                      message: this.$t('confirm.deleteCancelled'),
                    });
                  });
              } else {
                this.$message({ showClose: true, type: 'error', message: res.data.msg });
              }
            }
          });
      },
      updateFormData() {
        // 获取表单数据
        this.formData = {
          ...this.$refs.basicInfo.baseData,
          ...this.$refs.receivablesInfo.baseData,
        };
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManage.message.${info}`),
          type: type,
        });
      },
      handleTabClick(e) {
        if (e.name == 'first') {
          this.$refs.firstClaim.secondTableData = XEUtils.clone(
            this.$refs.secondClaim.$refs.table.getTableData().fullData,
            true
          );
        }
        // 重新调用接口获取数据
        this.getDetail(this.formData.id);
      },
      beforeLeave(item) {
        // 切换tab到二次认领前，校验一次认领是否改动，若改动是否保存数据，未保存不能进行二次认领
        let flag = true;
        if (item == 'second') {
          let firstClaimRecords = this.$refs.firstClaim.$refs.table.getRecordset();
          if (
            firstClaimRecords.insertRecords.length > 0 ||
            firstClaimRecords.removeRecords.length > 0 ||
            firstClaimRecords.updateRecords.length > 0
          ) {
            this.$message({
              showClose: true,
              message: '一次认领改动未保存！请先保存一次认领再进行二次认领！',
              type: 'warning',
            });
            flag = false;
          }
        }
        return flag;
      },
      // 上传附件成功
      handleUpload(uploadTableData) {
        this.capitalAttachmentList = uploadTableData;
        let params = {
          registerNo: this.formData.registerNo,
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
          companyName: this.userInfo.companyName,
          departmentName: this.userInfo.departmentName,
          fundAttachmentList: this.capitalAttachmentList,
        };
        this.$axios.post(API.SAVE_ATTACHMENT, params).then((res) => {
          if (res.data.code == 0) {
            return;
          }
        });
      },
      // 获取附件详情
      queryAttachment(registerNo) {
        let params = {
          registerNo: registerNo,
          tenantCode: this.userInfo.tenantCode,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
          companyName: this.userInfo.companyName,
          departmentName: this.userInfo.departmentName,
        };
        this.$axios.post(API.QUERY_ATTACHMENT, params).then((res) => {
          if (res.data.code == 0) {
            return (this.capitalAttachmentList = res.data.data.returnAttachmentList || []);
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .addClaim {
    .collapse-main-content {
      padding-bottom: 80px;
    }
    .padding0 {
      padding: 0;
    }
  }
</style>
